import { render, staticRenderFns } from "./StorageSpaceForm.vue?vue&type=template&id=cbaf47c4&"
import script from "./StorageSpaceForm.vue?vue&type=script&lang=js&"
export * from "./StorageSpaceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports